import { defineStore } from "pinia";

export const useCalcStore = defineStore("calc", {
  state: () => ({
    calcValue: false,
  }),
  actions: {
    setCalc(val) {
      this.calcValue = val;
    },
    clearCalc() {
      this.calcValue = false;
    },
  },
});
